/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadDocumentInput } from './UploadDocumentInput';
import {
    UploadDocumentInputFromJSON,
    UploadDocumentInputFromJSONTyped,
    UploadDocumentInputToJSON,
    UploadDocumentInputToJSONTyped,
} from './UploadDocumentInput';

/**
 * 
 * @export
 * @interface PortalUploadBatchRequest
 */
export interface PortalUploadBatchRequest {
    /**
     * 
     */
    batch_id: string;
    /**
     * 
     */
    request_item_id?: string | null;
    /**
     * 
     */
    message_id?: string | null;
    /**
     * 
     */
    documents: Array<UploadDocumentInput>;
}

/**
 * Check if a given object implements the PortalUploadBatchRequest interface.
 */
export function instanceOfPortalUploadBatchRequest(value: object): value is PortalUploadBatchRequest {
    if (!('batch_id' in value) || value['batch_id'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function PortalUploadBatchRequestFromJSON(json: any): PortalUploadBatchRequest {
    return PortalUploadBatchRequestFromJSONTyped(json, false);
}

export function PortalUploadBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalUploadBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'batch_id': json['batch_id'],
        'request_item_id': json['request_item_id'] === undefined ? undefined : json['request_item_id'] === null ? null : json['request_item_id'],
        'message_id': json['message_id'] === undefined ? undefined : json['message_id'] === null ? null : json['message_id'],
        'documents': ((json['documents'] as Array<any>).map(UploadDocumentInputFromJSON)),
    };
}

export function PortalUploadBatchRequestToJSON(json: any): PortalUploadBatchRequest {
    return PortalUploadBatchRequestToJSONTyped(json, false);
}

export function PortalUploadBatchRequestToJSONTyped(value?: PortalUploadBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batch_id'],
        'request_item_id': value['request_item_id'],
        'message_id': value['message_id'],
        'documents': ((value['documents'] as Array<any>).map(UploadDocumentInputToJSON)),
    };
}

